





















import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";

export interface Data {
  errors: any[],
}

export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      errors: [],
    });

    const download = async () => {
      window.location.href = `/api/teacher/student_excel_upload/download`;
    }

    const upload = async (file: any) => {   
      let fd = new FormData();
      fd.append('upload[file]', file);

      context.root.$store.dispatch("showOverlay", "ファイル読み込み中");
      state.errors = [];
      await http.post(`/api/teacher/student_excel_upload/upload`, fd).then(response => {
        alert("アップロードが完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    return {
      ...toRefs(state),
      download,
      upload,
    }
  }
});
